/**
 * Next live Bootcamp class helpers (Rob, 2026-10-28).
 *
 * When a live cohort is closed, the live page and the pricing page say when
 * the next live class starts. The date always comes from data: the first
 * session of each cohort in bootcamp-data, or the catalog cohort metadata.
 * Nothing here holds a date of its own.
 */

/** First session date of every cohort bootcamp-data returns (current and future). */
export const cohortStartsFrom = (sessionGroups) => {
  const groups = [sessionGroups?.current, ...(sessionGroups?.future || [])].filter(Boolean);
  return groups
    .map((group) => {
      const first = (group.sessions || [])
        .map((session) => new Date(session.scheduledAt))
        .filter((date) => !Number.isNaN(date.getTime()))
        .sort((a, b) => a - b)[0];
      return first ? { name: group.name || null, startsAt: first } : null;
    })
    .filter(Boolean);
};

/** The earliest cohort start still ahead of `now`, or null. */
export const nextCohortStartFrom = (candidates, now = Date.now()) =>
  candidates
    .filter((date) => date instanceof Date && !Number.isNaN(date.getTime()))
    .filter((date) => date.getTime() > now)
    .sort((a, b) => a - b)[0] || null;

/** "Wed, Mar 17, 2027" in Eastern time, the Bootcamp's class time zone. */
export const formatNextLiveClassDate = (date) =>
  date
    ? new Date(date).toLocaleDateString('en-US', {
        weekday: 'short',
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        timeZone: 'America/New_York',
      })
    : null;
